// extracted by mini-css-extract-plugin
export default {"img":"TenorAttribution-img-48452e3685d639d025f25bc6aaa0cc89"};